export const NOTIFICATION_REMOVAL_THROTTLE_INTERVAL = 2000;
export const NOTIFICATION_LIFESPAN = 10000;
